<template>
    <default-layout>
        <div class="row">
            <div class="col-12">
                <h1 class="h4 mb-4 clearfix">
                    Edit customer
                </h1>
            </div>
        </div>

        <div class="row" v-if="loading === true">
            <div class="col-12">
                <spinner-component class="p-5" type="spinner-grow"/>
            </div>
        </div>

        <form @submit.prevent="onSubmit" v-if="loading === false">

            <div class="row">
                <!-- CUSTOMER DETAILS -->
                <div class="col-lg-4 col-md-12">
                    <h2 class="h6">Customer details</h2>
                    <hr>

                    <div class="form-group">
                        <label for="email">Email</label>
                        <input class="form-control" id="email" type="text" v-model="customer.email" disabled="disabled">
                    </div>
                    <div class="form-group">
                        <label for="salutation">Salutation</label>
                        <select class="form-control" id="salutation" v-model="customer.salutation">
                            <option value="MR">Mr.</option>
                            <option value="MS">Ms.</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="first-name">First name</label>
                        <input class="form-control" id="first-name" type="text" v-model="customer.firstName">
                    </div>
                    <div class="form-group">
                        <label for="last-name">Last name</label>
                        <input class="form-control" id="last-name" type="text" v-model="customer.lastName">
                    </div>
                    <div class="form-group">
                        <label for="birthday">Birthday</label>
                        <input class="form-control" id="birthday" type="date" v-model="customer.birthday">
                    </div>
                    <div class="form-group">
                        <label for="company">Company</label>
                        <input class="form-control" id="company" type="text" v-model="customer.company">
                    </div>
                    <div class="form-group">
                        <label for="street">Street</label>
                        <input class="form-control" id="street" type="text" v-model="customer.street">
                    </div>
                    <div class="form-group">
                        <label for="postcode">Postcode</label>
                        <input class="form-control" id="postcode" type="text" v-model="customer.postcode">
                    </div>
                    <div class="form-group">
                        <label for="city">City</label>
                        <input class="form-control" id="city" type="text" v-model="customer.city">
                    </div>
                    <div class="form-group">
                        <label for="country">Country</label>
                        <country-select class="form-control" id="country" v-model="customer.country" :country="customer.country"/>
                    </div>
                    <div class="form-group">
                        <label for="state">State</label>
                        <input class="form-control" id="state" type="text" v-model="customer.state">
                    </div>
                </div>

                <!-- BILLING ADDRESS -->
                <div class="col-lg-4 col-md-12">
                    <h2 class="h6">Billing Address</h2>
                    <hr>

                    <div class="form-group">
                        <label for="billing-salutation">Salutation</label>
                        <select class="form-control" id="billing-salutation" v-model="customer.billingAddress.salutation">
                            <option value="MR">Mr.</option>
                            <option value="MS">Ms.</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="billing-first-name">First name</label>
                        <input class="form-control" id="billing-first-name" type="text" v-model="customer.billingAddress.firstName">
                    </div>
                    <div class="form-group">
                        <label for="billing-last-name">Last name</label>
                        <input class="form-control" id="billing-last-name" type="text" v-model="customer.billingAddress.lastName">
                    </div>
                    <div class="form-group">
                        <label for="billing-birthday">Birthday</label>
                        <input class="form-control" id="billing-birthday" type="date" v-model="customer.billingAddress.birthday">
                    </div>
                    <div class="form-group">
                        <label for="billing-company">Company</label>
                        <input class="form-control" id="billing-company" type="text" v-model="customer.billingAddress.company">
                    </div>
                    <div class="form-group">
                        <label for="billing-vat-id">VAT ID</label>
                        <input class="form-control" id="billing-vat-id" type="text" v-model="customer.billingAddress.vatId">
                    </div>
                    <div class="form-group">
                        <label for="billing-street">Street</label>
                        <input class="form-control" id="billing-street" type="text" v-model="customer.billingAddress.street">
                    </div>
                    <div class="form-group">
                        <label for="billing-postcode">Postcode</label>
                        <input class="form-control" id="billing-postcode" type="text" v-model="customer.billingAddress.postcode">
                    </div>
                    <div class="form-group">
                        <label for="billing-city">City</label>
                        <input class="form-control" id="billing-city" type="text" v-model="customer.billingAddress.city">
                    </div>
                    <div class="form-group">
                        <label for="billing-country">Country</label>
                        <country-select class="form-control" id="billing-country" v-model="customer.billingAddress.country" :country="customer.billingAddress.country"/>
                    </div>
                    <div class="form-group">
                        <label for="billing-state">State</label>
                        <input class="form-control" id="billing-state" type="text" v-model="customer.billingAddress.state">
                    </div>
                </div>

                <!-- SHIPPING ADDRESS -->
                <div class="col-lg-4 col-md-12">
                    <h2 class="h6">Shipping Address</h2>
                    <hr>

                    <div class="form-group">
                        <label for="shipping-salutation">Salutation</label>
                        <select class="form-control" id="shipping-salutation" v-model="customer.shippingAddress.salutation">
                            <option value="MR">Mr.</option>
                            <option value="MS">Ms.</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="shipping-first-name">First name</label>
                        <input class="form-control" id="shipping-first-name" type="text" v-model="customer.shippingAddress.firstName">
                    </div>
                    <div class="form-group">
                        <label for="shipping-last-name">Last name</label>
                        <input class="form-control" id="shipping-last-name" type="text" v-model="customer.shippingAddress.lastName">
                    </div>
                    <div class="form-group">
                        <label for="shipping-birthday">Birthday</label>
                        <input class="form-control" id="shipping-birthday" type="date" v-model="customer.shippingAddress.birthday">
                    </div>
                    <div class="form-group">
                        <label for="shipping-company">Company</label>
                        <input class="form-control" id="shipping-company" type="text" v-model="customer.shippingAddress.company">
                    </div>
                    <div class="form-group">
                        <label for="shipping-vat-id">VAT ID</label>
                        <input class="form-control" id="shipping-vat-id" type="text" v-model="customer.shippingAddress.vatId">
                    </div>
                    <div class="form-group">
                        <label for="shipping-street">Street</label>
                        <input class="form-control" id="shipping-street" type="text" v-model="customer.shippingAddress.street">
                    </div>
                    <div class="form-group">
                        <label for="shipping-postcode">Postcode</label>
                        <input class="form-control" id="shipping-postcode" type="text" v-model="customer.shippingAddress.postcode">
                    </div>
                    <div class="form-group">
                        <label for="shipping-city">City</label>
                        <input class="form-control" id="shipping-city" type="text" v-model="customer.shippingAddress.city">
                    </div>
                    <div class="form-group">
                        <label for="shipping-country">Country</label>
                        <country-select class="form-control" id="shipping-country" v-model="customer.shippingAddress.country" :country="customer.shippingAddress.country"/>
                    </div>
                    <div class="form-group">
                        <label for="shipping-state">State</label>
                        <input class="form-control" id="shipping-state" type="text" v-model="customer.shippingAddress.state">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <button class="btn btn-primary" type="submit">
                        <font-awesome-icon class="mr-1" icon="save"/>
                        Save
                    </button>
                </div>
            </div>

        </form>

    </default-layout>
</template>

<script>
    import DefaultLayout from "../components/layout/DefaultLayout";
    import SpinnerComponent from "../components/ui/SpinnerComponent";

    export default {
        name: "CustomerDetailsPage",
        components: { SpinnerComponent, DefaultLayout },
        computed: {
            cliffMarketModule() {
                return this.$store.state.cliffMarket;
            },
            customer() {
                return this.$store.state.cliffMarket.customer;
            },
            customerId() {
                let customerId = null;

                if (Object.prototype.hasOwnProperty.call(this.$route.params, 'customerId')) {
                    customerId = this.$route.params.customerId;
                    customerId = customerId ? customerId : null;
                }

                return customerId;
            }
        },
        data() {
            return {
                loading: true
            }
        },
        methods: {
            async onSubmit() {
                this.loading = true;
                this.$store.dispatch('alert/clear');

                this.$store.dispatch('cliffMarket/updateCustomer', this.customer)
                    .then(() => {
                        this.$store.dispatch('alert/success', 'Customer updated successfully.');
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            }
        },
        async beforeMount() {
            if (this.customerId !== null) {
                await this.$store.dispatch('cliffMarket/getCustomer', this.customerId);
            }

            this.loading = false;
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>

</style>